import EmptyState, { EmptyStateProps } from "./EmptyState";

export default EmptyState;
export type Props = EmptyStateProps;
